import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import { fetchLaymansIndications } from "../../medPracapi";

function NappiSearch({ onNappiSelect }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  // Debounced lookup
  useEffect(() => {
    const q = searchQuery.trim();
    if (q.length < 3) {
      setResults([]);
      return;
    }

    let isCancelled = false;
    setLoading(true);
    const t = setTimeout(async () => {
      const data = await fetchLaymansIndications(q, 50);
      if (!isCancelled) setResults(data);
      setLoading(false);
    }, 250); // debounce keystrokes

    return () => {
      isCancelled = true;
      clearTimeout(t);
    };
  }, [searchQuery]);

  const handleClick = (item) => {
    onNappiSelect?.(item);
    setSearchQuery(`${item.nappiCode} - ${item.description}`);
    // optionally clear the result list after select
    setResults([]);
  };

  return (
    <div>
      <Form.Control
        id={`nappi-search-${Math.random()}`}
        name="nappiSearch"
        type="text"
        placeholder="Search NAPPI (code or description, min 3 chars)"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      {loading && <div className="small text-muted mt-1">Searching…</div>}

      {results.length > 0 && (
        <div className="results-box mt-1">
          {results.map((item, idx) => (
            <div
              key={`${item.nappiCode}-${idx}`}
              className="result-item"
              onClick={() => handleClick(item)}
              style={{ cursor: "pointer" }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#0F3490";
                e.currentTarget.style.fontWeight = "bold";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "black";
                e.currentTarget.style.fontWeight = "normal";
              }}
            >
              {item.nappiCode} - {item.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default NappiSearch;
